import {
  FETCH_INTEGRATIONS_START,
  FETCH_INTEGRATIONS_SUCCESS,
  FETCH_INTEGRATIONS_ERROR,
  RESET,
} from '../actions/actionTypes';
import {
  FETCH_ALL_INTEGRATION_CREDENTIALS_START,
  FETCH_ALL_INTEGRATION_CREDENTIALS_SUCCESS,
  FETCH_ALL_INTEGRATION_CREDENTIALS_ERROR,
  FETCH_INTEGRATION_CREDENTIAL_SUCCESS,
  CREATE_INTEGRATION_CREDENTIAL_SUCCESS,
  UPDATE_INTEGRATION_CREDENTIAL_SUCCESS,
  DELETE_INTEGRATION_CREDENTIAL_SUCCESS,
} from '../actions/types';

export const initialState = {
  fetchingData: false,
  error: null,
  data: null,
};

/**
 * @constant {String} FETCH_ALL_INTEGRATION_CREDENTIALS_... - fetches all inbound data
 * @constant {String} FETCH_INTEGRATIONS_... - fetches all outbound data -TODO: more consistent name
 */

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INTEGRATIONS_START: {
      return {
        ...state,
        fetchingData: true,
        error: null,
      };
    }
    case FETCH_INTEGRATIONS_SUCCESS: {
      return {
        ...state,
        fetchingData: false,
        error: null,
        data: action.payload,
      };
    }
    case FETCH_INTEGRATIONS_ERROR: {
      return {
        ...state,
        fetchingData: false,
        error: action.payload,
        data: null,
      };
    }
    case FETCH_ALL_INTEGRATION_CREDENTIALS_START: {
      return {
        ...state,
        fetchingData: true,
        error: null,
      };
    }
    case FETCH_ALL_INTEGRATION_CREDENTIALS_SUCCESS: {
      return {
        ...state,
        fetchingData: false,
        error: null,
        data: action.payload,
      };
    }
    case FETCH_ALL_INTEGRATION_CREDENTIALS_ERROR: {
      return {
        ...state,
        fetchingData: false,
        error: action.payload,
        data: null,
      };
    }
    case CREATE_INTEGRATION_CREDENTIAL_SUCCESS: {
      return {
        data: {
          ...state.data,
          credentials: [...state.data.credentials, action.payload],
        },
        fetchingData: false,
        error: null,
      };
    }
    case UPDATE_INTEGRATION_CREDENTIAL_SUCCESS: {
      const internalID = action.payload.internal_id;
      const updatedData = state.data.credentials.map(d => {
        if (d.internal_id === internalID) {
          return action.payload;
        }
        return d;
      });
      return {
        fetchingData: false,
        error: null,
        data: {
          ...state.data,
          credentials: updatedData,
        },
      };
    }
    case DELETE_INTEGRATION_CREDENTIAL_SUCCESS: {
      const filteredData = state.data.credentials.filter(
        d => d.internal_id !== action.payload, //action.payload is deleted cred.internal_id
      );
      return {
        data: {
          ...state.data,
          credentials: filteredData,
        },
        fetchingData: false,
        error: null,
      };
    }
    case FETCH_INTEGRATION_CREDENTIAL_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        error: null,
      };
    case RESET:
      return {
        fetchingData: false,
        error: null,
        data: null,
      };
    default:
      return state;
  }
};
